import * as React from "react";
const SvgBars3 = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M4 6h16M4 12h16M4 18h16" }));
export default SvgBars3;
